import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import styled from "styled-components/macro";
import Api from '../contexts/Api';
import { formatDate, formatTime, switchRole } from '../contexts/Utils';
import { Button } from '../components/StyledComponents';
import Loading from "../components/generic/Loading";
import sphere from '../assets/entire-sphere.png';
import stBernard from '../assets/st-bernard-white.png';
import noMissions from '../assets/no-missions.png';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const DriverHome = () => {
  const cookies = useMemo(() => new Cookies(), []);
  const user = cookies.get(process.env.REACT_APP_USER_COOKIE);
  const [missions, setMissions] = useState([]);
  const [loading, setLoading] = useState(true);

  // 
  // ─── GET PROPOSALS ───────────────────────────────────────
  //
  useEffect(() => {
    const getMissions = async () => {
      let query = { driver_id: user.user_id, invited_driver_id: JSON.stringify([user.user_id]), status: 2, withMissions: true, subtype: true, noSolo: true }

      const params = {
        endpoint: '/proposals',
        method: 'GET',
        query
      }
      const proposalsQuery = await Api(params);

      setLoading(false);
      if (proposalsQuery.data) setMissions(proposalsQuery.data['2']);
    }

    getMissions();
  }, [user.user_id]);

  // //
  // // ─── CHECK IF SUBSCRIPTION IS COMPLETED ───────────────────────────────────────
  // //
  // useEffect(() => {
  //   const checkSubscriptionValidity = async () => {
  //     const search = new URLSearchParams(window.location.search);

  //     // if no success, paiement failed
  //     const querySuccess = search.get('success');
  //     if (querySuccess === null || !Number(querySuccess)) return;

  //     // check session validity -> add to db if success
  //     const session_id = search.get('session_id');

  //     if (session_id) {
  //       const params = {
  //         endpoint: `/stripe/subscription/validate`,
  //         method: 'POST',
  //         data: { session_id }
  //       }
  //       const query = await Api(params);
  //       if (query.success) {
  //         const newUserData = {
  //           ...user,
  //           stripe_subscription_enabled: 1
  //         };

  //         cookies.set(process.env.REACT_APP_USER_COOKIE, newUserData, {
  //           expires: new Date(Date.now() + 604800000), // time until expiration
  //           secure: false, // true if using https
  //           path: '/' // if not set, will gen cookie for different pages
  //         })
  //       }
  //     }
  //   }

  //   checkSubscriptionValidity();
  // }, [cookies, user])

  //
  // ─── MISSIONS LIST CARD RENDER ───────────────────────────────────────
  //
  const MissionCard = (props) => {
    const { mission } = props;

    return <S.CardContainer to={`/trajets/${mission.mission_id}`}>
      <h3 className='cities'>{mission.origin_city} <span>→</span> {mission.destination_city}</h3>
      <S.TimeData>
        {mission.date_type === 1 ? <span>Dès que possible</span> : <span>{formatDate({ display: 'date', time: mission.date })} à {formatDate({ display: 'timer', time: mission.date })}</span>}
        <span>{mission.distance}km - {formatTime({ duration: mission.duration, display: 'hour' })}</span>
      </S.TimeData>
      <S.Options>
        <span>
          <svg className='car' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" /></svg>
          {Boolean(mission.recovery) ? <svg className='loop' width="188" height="227" viewBox="0 0 188 227" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M71.3225 221.679C78.6663 228.774 90.5925 228.774 97.9363 221.679C105.28 214.585 105.28 203.064 97.9363 195.97L83.0138 181.611H94C145.935 181.611 188 140.976 188 90.8057C188 40.6355 145.935 0 94 0H18.8C8.40124 0 0 8.11576 0 18.1611C0 28.2065 8.40124 36.3223 18.8 36.3223H94C125.138 36.3223 150.4 60.7263 150.4 90.8057C150.4 120.885 125.138 145.289 94 145.289H83.0138L97.9363 130.874C105.28 123.779 105.28 112.259 97.9363 105.164C90.5925 98.0701 78.6663 98.0701 71.3225 105.164L24.3225 150.567C16.9787 157.661 16.9787 169.182 24.3225 176.277L71.3225 221.679Z" /></svg>
            : <svg className='car-two' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" /></svg>
          }
          {Boolean(mission.recovery) ? 'Aller-retour' : 'Aller simple'}
        </span>
        <span className="see-details">Voir les détails</span>
      </S.Options>
    </S.CardContainer >
  }

  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <div style={{ padding: '0' }}>
    <S.Container>
      <S.Content>
        <S.Icons>
          <div>
            <img src={sphere} alt="sphère" />
          </div>
        </S.Icons>
        <S.Title>
          <img src={stBernard} alt="st-bernard" />
          <span className="vous-ramene">vous ramène</span>
          <br />vous et <span className="vous-votre-vehicule">votre véhicule</span>
          <br />
          <div className="line"></div>
          <span className="mode-chauffeur">Mode <span>chauffeur</span></span>
        </S.Title>
        <S.Missions>
          <h2>Missions à venir</h2>
          <Loading loading={loading}>
            {missions && missions.length > 0 ? missions.map(e => {
              if (e.proposal_status == 0) return null;
              if (!e || !e.mission_id) return null;
              return <MissionCard key={e.mission_id} mission={e} />
            })
              : <S.NoMissions>
                <img src={noMissions} alt="Aucune mission" />
                <span>Aucune mission !</span>
                <S.Button as={Link} to='/nouvelles-courses'>Trouver une mission</S.Button>
              </S.NoMissions>}
          </Loading>
          <svg className="desktop-line" width="858" height="315" viewBox="0 0 858 315" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3576 17C531.467 33.0217 555.176 68.978 544.088 98.2054C528.479 139.337 10.553 138.746 10.553 196.809C10.553 247.382 359.916 261.607 853.271 312" stroke="#43FFCF" strokeWidth="4" strokeMiterlimit="10" strokeDasharray="30 15" />
            <path d="M760.367 300.69C757.257 297 750.164 288.058 750.164 283.035C750.164 276.943 755.378 272 761.804 272C768.23 272 773.444 276.943 773.444 283.035C773.444 288.058 766.351 297 763.241 300.69C762.495 301.569 761.113 301.569 760.367 300.69ZM761.804 286.713C763.944 286.713 765.684 285.063 765.684 283.035C765.684 281.006 763.944 279.356 761.804 279.356C759.664 279.356 757.924 281.006 757.924 283.035C757.924 285.063 759.664 286.713 761.804 286.713Z" fill="#23ECB9" />
          </svg>
          <svg className="mobile-line" width="390" height="368" viewBox="0 0 390 368" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_331_384)">
              <path d="M-9.98063 44C254.271 60.0217 266.481 95.978 260.77 125.205C252.732 166.337 -14 165.746 -14 223.809C-14 274.382 165.922 288.607 420 339" stroke="#43FFCF" strokeWidth="4" strokeMiterlimit="10" strokeDasharray="30 15" />
              <path d="M283.642 310.69C280.703 307 274 298.058 274 293.035C274 286.943 278.927 282 285 282C291.073 282 296 286.943 296 293.035C296 298.058 289.297 307 286.358 310.69C285.653 311.569 284.347 311.569 283.642 310.69ZM285 296.713C287.022 296.713 288.667 295.063 288.667 293.035C288.667 291.006 287.022 289.356 285 289.356C282.978 289.356 281.333 291.006 281.333 293.035C281.333 295.063 282.978 296.713 285 296.713Z" fill="#23ECB9" />
            </g>
            <defs>
              <clipPath id="clip0_331_384">
                <rect width="419" height="368" fill="white" transform="matrix(-1 0 0 1 411 0)" />
              </clipPath>
            </defs>
          </svg>
        </S.Missions>
        {user.role === 3 && <S.Chauffeur onClick={() => switchRole(2)}>
          <div>
            <svg width="58" height="46" viewBox="0 0 58 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_332_382)">
                <path d="M30.5 8.49996C21.3 8.09996 19 21.3333 19 28C15.5 30.4999 14 40.5 20.5 44C25.7 46.8 30.6667 42.1667 32.5 39.5C33.8333 39.3333 38.4 39.1 46 39.5C53.6 39.9 53.1667 33.6667 52 30.5H56C58 19.3 53.5 15.8333 51 15.5C48 6 42 8.99996 30.5 8.49996Z" fill="white" />
                <mask id="mask0_332_382" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="58" height="46">
                  <path d="M58 0H0V46H58V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_332_382)">
                  <path d="M6.23005 22.9C7.95005 22.9 9.67005 22.9 11.3901 22.9C11.8801 22.9 12.3101 23.02 12.5601 23.49C12.7301 23.82 12.6401 24.13 12.4601 24.41C12.2301 24.78 11.8601 24.86 11.4701 24.86C8.03005 24.86 4.59005 24.87 1.15005 24.86C0.52005 24.86 -0.0199499 24.56 5.01421e-05 23.86C0.0200501 23.2 0.44005 22.88 1.15005 22.89C2.84005 22.92 4.53005 22.89 6.23005 22.89V22.9Z" fill="#404FE6" />
                  <path d="M10.31 26.8201C11.18 26.8201 12.06 26.8201 12.93 26.8201C13.56 26.8201 13.89 27.1101 13.89 27.7601C13.89 28.4301 13.56 28.8001 12.91 28.7901C11.11 28.7601 9.32001 28.8801 7.52001 28.7101C6.91001 28.6501 6.69001 28.3001 6.67001 27.8301C6.65001 27.3101 6.91001 26.8601 7.52001 26.8401C8.45001 26.8101 9.38001 26.8401 10.3 26.8401L10.31 26.8201Z" fill="#404FE6" />
                  <path d="M56.2202 18.84C55.4602 17.06 54.5402 15.44 52.3502 15.2C51.8702 15.15 51.8902 14.83 51.8102 14.52C50.8702 10.93 48.8802 8.40001 45.0002 7.78001C44.6602 7.72001 44.4202 7.53001 44.2102 7.25001C42.6902 5.24001 40.6202 3.89001 38.5402 2.56001C37.0302 1.60001 35.2702 1.23001 33.5802 0.760012C31.1902 0.100012 28.7302 -0.129988 26.2302 0.0700114C25.3202 0.150012 24.4502 0.340012 23.6702 0.790012C22.8102 1.29001 22.3202 2.00001 22.3502 3.07001C22.3702 4.19001 22.9202 5.03001 23.6002 5.83001C24.4102 6.77001 25.4702 7.39001 26.6902 7.97001C26.4202 8.10001 26.2802 8.15001 26.1402 8.22001C24.9502 8.80001 23.8502 9.46001 23.1102 10.63C22.4902 11.62 19.9102 12.15 19.6902 12.16C18.1802 12.21 16.6502 12.19 15.2802 11.57C14.4302 11.18 13.6102 10.83 12.6902 10.69C11.2102 10.46 9.95022 11.03 9.03022 12.07C8.11022 13.12 8.01022 14.46 8.60022 15.77C10.3002 19.43 13.2302 21.37 17.2102 21.77C18.7602 21.93 18.7602 21.89 18.6402 23.38C18.6302 23.54 18.6302 23.71 18.6202 23.87C18.4302 25.69 18.4402 27.4 17.1102 29.09C15.0502 31.69 14.8102 34.95 15.6302 38.21C16.3902 41.21 18.0602 43.53 20.8202 45.01C22.4402 45.87 24.1902 45.78 25.9502 45.72C29.0302 45.62 31.5602 44.59 33.2902 41.87C33.6902 41.24 33.9402 40.33 34.5602 40.05C35.2202 39.75 36.1102 39.98 36.9102 39.95C37.3202 39.93 37.5302 40.09 37.7302 40.45C38.3902 41.66 39.3702 42.64 40.4202 43.47C43.0202 45.52 46.0602 45.52 49.0202 44.66C52.1302 43.77 54.0202 41.57 54.7702 38.32C55.2402 36.27 55.1602 34.29 54.7202 32.3C54.4102 30.88 54.3502 30.89 55.8202 30.88C55.9002 30.88 55.9802 30.87 56.0602 30.88C56.7802 30.97 57.0502 30.59 57.0802 29.93C57.1202 29.14 57.1702 28.35 57.2402 27.57C57.5202 24.58 57.4302 21.65 56.2202 18.84ZM29.4702 40.9C26.8302 44.8 21.9402 45.08 18.8702 41.51C15.9702 38.13 15.9502 32.56 18.8202 29.17C21.4502 26.07 25.6202 25.9 28.4702 28.8C30.2902 30.65 31.0402 32.94 31.0902 35.23C31.0802 37.46 30.5702 39.27 29.4602 40.9H29.4702ZM42.5902 9.28001C43.8202 9.20001 45.0302 9.28001 46.1802 9.79001C46.2102 9.83001 46.2702 9.87001 46.2802 9.91001C46.5702 11.67 46.6302 13.42 46.2402 15.17C44.2902 15.56 42.8602 16.7 41.8002 18.34C42.4302 15.35 42.6602 12.33 42.5902 9.28001ZM37.7002 16.2C38.1602 16.09 38.6602 16.85 38.6202 17.61C38.5802 18.21 38.4802 18.95 37.7302 18.95C36.9802 18.95 36.9102 18.22 36.8302 17.62C36.9002 17 36.9802 16.38 37.7002 16.2ZM50.8302 35.32C50.8102 36.89 49.4002 38.31 47.8402 38.32C43.7902 38.34 39.7402 38.32 35.6902 38.34C35.2802 38.34 34.9802 38.39 35.0902 37.75C35.7502 33.93 34.8302 30.55 32.2102 27.66C32.3602 27.5 32.5602 27.51 32.7502 27.51C36.0102 27.66 38.0802 25.83 39.7702 23.33C39.9902 23.01 40.0202 22.52 40.5102 22.39C40.3602 23.52 40.2902 24.64 40.2902 25.77C40.2902 27.15 40.4002 28.53 40.5902 29.91C40.7002 30.74 41.0802 31.02 41.8802 31.02C44.5902 30.99 47.3002 31.02 50.0102 31C50.6202 30.99 50.8902 31.1 50.8502 31.79C50.7902 32.97 50.8502 34.15 50.8302 35.32ZM55.5602 28.81C55.5402 29.25 55.3302 29.35 54.9402 29.35C50.8902 29.34 46.8402 29.34 42.7902 29.34C42.4202 29.35 42.1702 29.29 42.1302 28.84C41.8702 26.16 41.8002 23.49 42.6002 20.87C42.9802 19.62 43.5802 18.5 44.6502 17.67C45.6402 16.91 46.7602 16.71 48.0402 16.89C47.7902 18.46 48.3502 19.34 49.9902 19.75C50.6402 19.9 50.7902 20.18 50.7802 20.8C50.7302 22.63 50.7702 24.46 50.7502 26.3C50.7402 26.59 51.0202 27.09 50.4402 27.15C49.8702 27.22 49.2602 27.24 48.9902 26.54C48.9402 26.42 48.9302 26.28 48.8902 26.14C48.8102 25.8 48.5902 25.63 48.2302 25.69C47.9002 25.75 47.8202 26 47.8102 26.31C47.7702 27.28 48.6402 28.24 49.7302 28.29C50.7102 28.35 51.7002 28.34 52.6802 28.3C53.7402 28.25 54.5702 27.39 54.6202 26.41C54.6302 26.05 54.5702 25.74 54.1402 25.69C53.7802 25.64 53.5902 25.85 53.5302 26.2C53.4802 26.47 53.4102 26.72 53.1802 26.92C52.8302 27.23 52.4102 27.24 52.0202 27.12C51.6902 27.01 51.8502 26.64 51.8502 26.39C51.8502 24.45 51.8602 22.51 51.8502 20.56C51.8402 20.12 51.9702 19.93 52.4102 19.88C53.0402 19.81 53.6702 19.63 54.1502 19.2C54.5502 18.84 54.6702 19.03 54.8102 19.4C55.4102 20.9 55.5902 22.47 55.7002 24.06C55.8102 25.64 55.6502 27.23 55.5702 28.81H55.5602Z" fill="#404FE6" />
                  <path d="M28.4701 9.27006C27.0601 9.28006 25.1701 10.3701 24.6501 11.4101C25.2301 11.3201 25.8001 11.2401 26.3601 11.1501C28.4801 10.8201 30.6101 10.8301 32.7401 11.0701C32.9001 11.1001 33.0901 11.1001 33.1701 11.2701C33.2601 11.4701 33.0901 11.5601 32.9601 11.6501C31.2301 12.7801 30.2901 14.5001 29.4501 16.3001C28.8001 17.7101 27.9401 18.9601 26.5701 19.7901C24.8901 20.8001 23.1301 21.5801 21.1601 21.7901C20.6701 21.8401 20.3401 22.0001 20.3001 22.5501C20.2401 23.4801 20.1601 24.4101 20.0801 25.3301C20.0501 25.7601 20.1201 25.8801 20.6201 25.7201C24.8101 24.3801 28.7501 24.6301 32.2101 27.6601C32.3601 27.5001 32.5601 27.5101 32.7501 27.5101C36.0101 27.6601 38.0801 25.8301 39.7701 23.3301C39.9901 23.0101 40.0201 22.5201 40.5101 22.3901C40.7701 20.9901 41.1701 19.6301 41.8001 18.3401C42.4301 15.3501 42.6601 12.3301 42.5901 9.28006C37.8901 9.28006 33.1801 9.25006 28.4701 9.27006ZM37.7301 18.9501C36.9901 18.9501 36.9101 18.2201 36.8301 17.6201C36.9001 17.0001 36.9801 16.3801 37.7001 16.2001C38.1601 16.0901 38.6601 16.8501 38.6201 17.6101C38.5801 18.2101 38.4801 18.9501 37.7301 18.9501Z" fill="#43FFCF" />
                  <path d="M49.7502 15.18C48.5802 15.18 47.4102 15.17 46.2402 15.17C46.6402 13.42 46.5702 11.67 46.2802 9.92004C46.2702 9.88004 46.2102 9.84004 46.1802 9.79004C48.5402 10.63 49.5602 12.55 50.2102 14.78C50.3502 15.27 50.0102 15.18 49.7602 15.18H49.7502Z" fill="#43FFCF" />
                  <path d="M51.4599 18.67C50.7699 18.71 50.1499 18.6 49.6099 18.25C49.0599 17.89 49.0599 17.56 49.5899 17.18C50.5099 16.53 52.4199 16.53 53.3299 17.18C53.8399 17.54 53.8399 17.91 53.2899 18.26C52.7199 18.62 52.0699 18.73 51.4499 18.67H51.4599Z" fill="#43FFCF" />
                  <path d="M39.42 16.19C39.06 15.48 38.49 15.01 37.67 15.05C36.85 15.08 36.3 15.58 35.99 16.3C35.66 17.05 35.61 17.83 35.88 18.62C36.21 19.57 36.88 20.12 37.72 20.12C38.56 20.13 39.24 19.6 39.57 18.65C39.68 18.31 39.64 16.63 39.42 16.19ZM37.73 18.95C36.99 18.95 36.91 18.22 36.83 17.62C36.9 17 36.98 16.38 37.7 16.2C38.16 16.09 38.66 16.85 38.62 17.61C38.58 18.21 38.48 18.95 37.73 18.95Z" fill="#404FE6" />
                  <path d="M28.1502 30.76C26.1302 27.97 22.5302 27.66 20.1002 30.08C17.1802 32.98 17.5002 38.61 20.7402 41.15C22.8202 42.78 25.5602 42.66 27.4702 40.84C29.0102 39.37 29.5902 37.51 29.6602 35.59C29.6202 33.73 29.1602 32.16 28.1502 30.76ZM19.7702 33.69C19.8702 33.25 19.9902 32.8 20.3702 32.4C20.6402 32.99 21.5702 33.2 21.1302 34.11C20.8202 34.74 20.2602 34.45 19.8502 34.4C19.3902 34.35 19.7002 33.93 19.7602 33.69H19.7702ZM20.9702 37.55C20.7402 37.73 20.6302 38.04 20.3302 38.17C20.0202 37.91 19.9402 37.52 19.8402 37.17C19.7602 36.87 19.4002 36.42 19.7902 36.24C20.1502 36.08 20.7302 35.95 21.0602 36.39C21.3202 36.74 21.4202 37.18 20.9702 37.54V37.55ZM22.8102 30.37C23.4202 30.33 22.9402 30.92 23.0802 31.08C23.1802 31.71 23.1102 32.16 22.4602 32.26C22.2902 32.28 21.3802 31.29 21.4602 31.16C21.7502 30.64 22.2902 30.4 22.8102 30.37ZM22.8102 40.35C22.2902 40.29 21.5602 40.06 21.5202 39.48C21.5002 39.14 21.9702 38.46 22.5002 38.46C23.1102 38.46 23.1902 39.03 23.0702 39.66C22.9402 39.81 23.4002 40.41 22.8102 40.34V40.35ZM23.8202 37.07C23.0402 37.06 22.4302 36.31 22.4302 35.37C22.4302 34.39 23.0002 33.7 23.8202 33.7C24.6102 33.7 25.2602 34.43 25.2802 35.35C25.3002 36.3 24.6402 37.09 23.8202 37.08V37.07ZM24.8402 40.41C24.3502 40.49 24.5802 39.99 24.5702 39.76C24.5402 39.23 24.4002 38.61 25.3002 38.51C25.7002 38.73 26.2302 39.21 26.1902 39.58C26.1202 40.16 25.3802 40.33 24.8402 40.42V40.41ZM25.1602 32.29C24.3002 32.09 24.5802 31.39 24.5602 30.84C24.5602 30.65 24.4002 30.3 24.8702 30.34C25.3702 30.56 25.9502 30.69 26.2502 31.22C26.3402 31.38 25.3402 32.34 25.1602 32.29ZM28.0402 36.68C27.9602 37.25 27.8402 37.86 27.3602 38.27C27.2502 38.36 26.4002 37.27 26.4202 37.03C26.4502 36.52 26.7502 36.24 27.2902 36.26C27.4702 36.49 28.1402 35.99 28.0502 36.68H28.0402ZM27.9402 34.48C27.5802 34.64 26.9902 34.77 26.6602 34.36C26.3602 34 26.2802 33.53 26.7602 33.14C26.9902 32.96 27.1502 32.7 27.3602 32.47C27.6802 32.82 27.8002 33.18 27.8902 33.54C27.9702 33.85 28.3202 34.31 27.9502 34.47L27.9402 34.48Z" fill="#404FE6" />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_332_382">
                  <rect width="58" height="46" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <span>Devenir <strong>Client</strong></span>
        </S.Chauffeur>}
      </S.Content>
      <S.Background></S.Background>
    </S.Container>
  </div>
};

export default DriverHome;

const S = {}
S.Container = styled.div`
  max-width: 800px;
  width: 100%;
  box-sizing: border-box;
  margin: auto;
  margin-top: 30px;
  overflow: hidden;
  padding: 0 20px;
  height: 100%;

  @media(min-width: 800px) {
    overflow: visible;
  }
`

S.Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`

S.Missions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 10px;
  background: ${({ theme }) => theme.card};
  box-sizing: border-box;
  border-radius: 5px;
  width: 100%;
  position: relative;

  h2 {
    margin-bottom: 10px;
  }

  .mobile-line {
    position: absolute;
    top: -60px;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  }
  .desktop-line {
    display: none;
    position: absolute;
    top: 0px;
    left: -35px;
    z-index: -1;
  }

  @media(min-width: 800px) {
    order: 3;
    border-radius: 20px;
    padding-bottom: 30px;

    .mobile-line {
      display: none;
    }
    .desktop-line {
      display: block;
    }
  }
`

S.Icons = styled.div`
  z-index: -1;
  margin-top: 20px;
  position: relative;
  height: 40px;

  div {
    top: 0;
    left: 0;
    margin-top: -40px;
    width: 1000px;
    height: 215px;
    overflow: hidden;

    img {
      width: 100%;
      animation: turn 130s infinite linear;

      @keyframes turn {
        0% {
          transform: rotate(0);
        }
        100% {
          transform: rotate(-360deg);
        }
      }
    }
  }

  @media(min-width: 500px) {
    div {
      width: 1350px;
      height: 275px;
    }
  }

  @media(min-width: 800px) {
    margin-top: 0;
    height: 15px;

    div {
      width: 1000px;
      height: 181px;
    }
  }
`

S.Title = styled.h1`
  color: ${({ theme }) => theme.text};
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 60px;

  img {
    width: 130px;
    margin-right: 10px;
    user-select: none;
    pointer-events: none;
  }
  .vous-ramene {
    display: inline-block;
    transform: translateY(-7.5px);
  }
  .vous-votre-vehicule {
    text-transform: uppercase;
    font-weight: 700;
  }
  .line {
    height: 1px;
    background: ${({ theme }) => theme.text};
    width: 35px;
    margin: auto;
    margin-top: 17px;
    margin-bottom: 10px;
  }
  .mode-chauffeur {
    font-size: 15px;

    span {
      font-weight: 700;
    }
  }

  @media(min-width: 800px) {
    order: 1;
    margin-bottom: 0;
    transform: translateY(-40px);
    font-size: 23px;
  }
`

S.Chauffeur = styled.div`
  align-self: flex-start;
  margin-top: auto;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: ${({ theme }) => `2px solid ${theme.primary}`};
    padding: 8px 9px;
    background: ${({ theme }) => theme.background};

    svg {
      width: 25px;
      height: 25px;
    }
  }

  span {
    display: none;
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.textInverse};
    padding: 12px 17px;
    padding-left: 25px;
    border-radius: 5px;
    position: absolute;
    white-space: nowrap;
    left: 35px;
    z-index: -1;
    font-size: 14px;

    strong {
      font-weight: 600;
    }
  }

  @media(min-width: 800px) {
    order: 4;
    margin-top: 30px;
    width: 207px;

    div {
      border-radius: 50%;
      border-width: 5px;
      padding: 8px 9px;
    }
    span {
      display: block;
    }
  }
`

S.Button = styled(Button)`
  width: 100%;
  border-radius: 0 0 5px 5px;
`

S.CardContainer = styled(Link)`
  border-radius: 5px;
  padding: 18px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 0;
  position: relative;
  max-width: 600px;
  transition: .3s;
  border-radius: 5px;

  :hover {
    background: ${({ theme }) => theme.background};
  }

  ::after {
    content: '';
    position: absolute;
    height: 1px;
    width: calc(100% - 38px);
    background: #636363;
    bottom: 0;
    left: 18px;
  }

  :last-of-type::after {
    display: none;
  }

  .cities {
    font-family: ${({ theme }) => theme.primaryFont};
    text-transform: uppercase;
    font-weight: 600;
    font-size: 17px;

    // arrow
    span {
      color: ${({ theme }) => theme.primary};
    }
  }
`

S.TimeData = styled.div`
  display: flex;
  justify-content: space-between;
  row-gap: 10px;
  flex-wrap: wrap;
`

S.Options = styled.div`
  display: flex;
  row-gap: 10px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.primary};
  }
  .car {
    width: 19px;
    margin-right: 4px;
  }
  .loop {
    width: 12px;
    height: fit-content;
    margin-right: 10px;
  }
  .car-two {
    width: 17px;
    margin-right: 10px;
  }
  .see-details {
    font-weight: 600;
  }
  span {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.primary};
  }
`

S.Background = styled.div`
  position: fixed;
  inset: 0;
  z-index: -1;
  background: #232323a8;
`

S.NoMissions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 15px;

  img {
    width: 130px;
    pointer-events: none;
    user-select: none;
  }

  a {
    height: fit-content;
    width: fit-content;
    border-radius: 5px;
  }
`

S.Chauffeur = styled.div`
  align-self: flex-start;
  margin-top: auto;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: ${({ theme }) => `2px solid ${theme.primary}`};
    padding: 8px 9px;
    background: ${({ theme }) => theme.background};
    z-index: 2;

    svg {
      width: 25px;
      height: 25px;
    }
  }

  span {
    display: none;
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.textInverse};
    padding: 12px 17px;
    padding-left: 25px;
    border-radius: 5px;
    position: absolute;
    white-space: nowrap;
    left: 35px;
    z-index: 1;
    font-size: 14px;

    strong {
      font-weight: 600;
    }
  }

  @media(min-width: 800px) {
    order: 4;
    margin-top: 30px;
    width: 207px;

    div {
      border-radius: 50%;
      border-width: 5px;
      padding: 8px 9px;
    }
    span {
      display: block;
    }
  }
`